import React from "react";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./DismissibleTooltip.module.css";

// A component for showing rendering tooltip content to be used with the DismissibleIllustration component
// the dismiss prop is the function returned from the useDismissibleIllustration hook

type Props = {
	dismiss?: () => void;
	icon: IconDefinition;
	text: string | React.ReactNode;
};

export default function DismissibleTooltip(props: Props) {
	const { icon, text } = props;

	return (
		<div className={styles.container}>
			<button className={styles.closeButton} onClick={props.dismiss}>
				<FontAwesomeIcon icon={faTimes} />
			</button>
			<div className={styles.star}>
				<FontAwesomeIcon icon={icon} />
			</div>
			<div className={styles.text}>{text}</div>
		</div>
	);
}
